<template lang="pug">
  div()
    router-view()
</template>
<script>
export default {};
</script>
<style scoped lang="stylus"></style>
